// extracted by mini-css-extract-plugin
export default {"msgM":"_31f61a3cf6"};